export const SET_PAGES = 'SET_PAGES';
export const SET_PAGE = 'SET_PAGE';
export const UPDATE_PAGE = 'UPDATE_PAGE';


export function setPages(list) {
    return { type: SET_PAGES, list };
}
export function setPage(list) {
    return { type: SET_PAGE, list };
}

export function updatePage(page) {
    return { type: UPDATE_PAGE, page };
}